// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vulpix_alola: PokeData = {
  "id": 10103,
  "name": "vulpix-alola",
  "height": 6,
  "weight": 99,
  "base_experience": 60,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "roar",
    "disable",
    "mist",
    "ice-beam",
    "blizzard",
    "aurora-beam",
    "confuse-ray",
    "spite",
    "powder-snow",
    "feint-attack",
    "icy-wind",
    "safeguard",
    "imprison",
    "grudge",
    "extrasensory",
    "sheer-cold",
    "payback",
    "ice-shard",
    "captivate",
    "hex",
    "freeze-dry",
    "dazzling-gleam",
    "baby-doll-eyes",
    "aurora-veil"
  ],
  "moves": [
    "tackle",
    "blizzard",
    "confuse-ray",
    "sheer-cold",
    "ice-shard",
    "dazzling-gleam",
    "aurora-veil",
    "chilly-reception",
    "ice-fang",
    "avalanche",
    "icicle-dagger",
    "hailstorm",
    "ice-punch"
  ],
  "evolution_chain": {
    "id": 15,
    "item": null,
    "species": [
      {
        "name": "vulpix",
        "order": 39,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninetales",
        "order": 40,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 37,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 130,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
